var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ActivtyTask" } },
    [
      _c("h1", [_vm._v("Task Hareketleri")]),
      _vm._v(" "),
      _c("a-card", { staticClass: "activity-container" }, [
        _vm.activities === null
          ? _c("div", { staticClass: "empty-state" }, [
              _c("p", [_vm._v("Yükleniyor...")]),
            ])
          : _vm.activities && _vm.activities.length
          ? _c(
              "div",
              { staticClass: "activity-list" },
              _vm._l(_vm.activities, function (activity) {
                return _c(
                  "a-card",
                  { key: activity._id, staticClass: "activity-item" },
                  [
                    _c("div", { staticClass: "activity-header" }, [
                      _c(
                        "div",
                        { staticClass: "user-info" },
                        [
                          activity.actor === "user"
                            ? _c("Avatar", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                  },
                                ],
                                attrs: {
                                  size: 25,
                                  src:
                                    _vm.usersMap[activity.actorUser] &&
                                    _vm.usersMap[activity.actorUser].gravatar,
                                  username:
                                    _vm.usersMap[activity.actorUser] &&
                                    _vm.usersMap[activity.actorUser].name,
                                  content:
                                    _vm.usersMap[activity.actorUser] &&
                                    _vm.usersMap[activity.actorUser].email,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          activity.actor === "chatbot"
                            ? _c("Avatar", {
                                staticClass: "avatar",
                                attrs: {
                                  username: "Chatbot",
                                  src: _vm
                                    .baseUrl()
                                    .concat("static/img/chatbot-bg.png"),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          activity.actor === "system"
                            ? _c("Avatar", {
                                staticClass: "avatar",
                                attrs: {
                                  username: "System",
                                  src: _vm
                                    .baseUrl()
                                    .concat("static/img/minilogo4.png"),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          activity.actor === "user"
                            ? _c("span", { staticClass: "user-name" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      (_vm.usersMap[activity.actorUser] &&
                                        _vm.usersMap[activity.actorUser]
                                          .name) ||
                                        "Bilinmeyen Kullanıcı"
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          activity.actor === "chatbot"
                            ? _c("span", { staticClass: "user-name" }, [
                                _vm._v(
                                  "\n                            ChatBot\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          activity.actor === "system"
                            ? _c("span", { staticClass: "user-name" }, [
                                _vm._v(
                                  "\n                            System\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "activity-time" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$moment(activity.updatedAt).fromNow()) +
                            "\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "activity-content",
                      domProps: {
                        innerHTML: _vm._s(_vm.getActivityContent(activity)),
                      },
                    }),
                  ]
                )
              }),
              1
            )
          : _c("div", [_c("p", [_vm._v("Herhangi bir hareket bulunamadı.")])]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }